export class ListSavedQueriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "savedQueries",
            "baseName": "savedQueries",
            "type": "Array<SavedQuery>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSavedQueriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
